import { ObsEncoderInfo } from '../types/obs';
import { ensureOBSPresence, obsSanityCheckFailed } from '../utils/ensureOBSPresence';
import { promisefy } from '../utils/promisefy';

const videoEncoderClassesPrioritizecList = [
    // NVIDIA NVENC
    'obs_nvenc_h264_tex',
    'obs_nvenc_hevc_tex',
    'obs_nvenc_h264_cuda', // Deprecated
    'obs_nvenc_hevc_cuda', // Deprecated
    'ffmpeg_nvenc', // Deprecated
    'ffmpeg_hevc_nvenc', // Deprecated
    'jim_nvenc', // Deprecated

    // AMD Advanced Media Framework (AMF)
    'amd_amf_h264',
    'amd_amf_h265',

    // Intel Quick Sync Video (QSV)
    'obs_qsv11_v2',
    'obs_qsv11_hevc',
    'obs_qsv11', // Deprecated

    // Apple VideoToolbox (VT)
    'com.apple.videotoolbox.videoencoder.ave.avc',
    'com.apple.videotoolbox.videoencoder.ave.hevc',
    'vt_h264_hw',
    'com.apple.videotoolbox.videoencoder.h264', // Software
    'com.apple.videotoolbox.videoencoder.hevc.vcp', // Software
    'vt_h264_sw', // Software

    'obs_x264', // Software
];

let g_defaultVideoEncoder : ObsEncoderInfo | null = null;

function getVideoEncoderWithDefaults(encoder: ObsEncoderInfo): ObsEncoderInfo
{
    const e = structuredClone(encoder);

    e.settings = e.settings || {};

    if ('bitrate' in (e.defaultSettings || {})) {
        e.settings['bitrate'] = 3000; // Kbps
    }

    return e;
}

export async function getDefaultVideoEncoder(): Promise<ObsEncoderInfo>
{
    await ensureOBSPresence();

    const all = (await promisefy(window.host.getAllAvailableVideoEncoderClasses)()) || [];

    if (!g_defaultVideoEncoder) {
        for (const encoderClass of videoEncoderClassesPrioritizecList) {
            if (window.host.getAvailableVideoEncoderClassProperties) {
                g_defaultVideoEncoder = await promisefy(window.host.getAvailableVideoEncoderClassProperties)({ class: encoderClass, settings: {} });
            } else {
                g_defaultVideoEncoder = all.find((item) => item.class === encoderClass) ?? null;
            }

            if (g_defaultVideoEncoder) {
                break;
            }
        }
    }

    if (!g_defaultVideoEncoder) {
        g_defaultVideoEncoder = all[0];
    }

    return getVideoEncoderWithDefaults(g_defaultVideoEncoder);
}

export async function getAvailableEncoders(type: 'audio' | 'video'): Promise<ObsEncoderInfo[]> {
    await ensureOBSPresence();

    let result: ObsEncoderInfo[] = [];

    if (type === 'video') {
        result = (await promisefy(window.host.getAllAvailableVideoEncoderClasses)()) || [];
    } else {
        result = (await promisefy(window.host.getAllAvailableAudioEncoderClasses)()) || [];
    }
  
    if (!result?.length) {
        console.warn(`Failed to get available ${type} encoders: `, result);
    }
  
    if (!result.length) {
        await obsSanityCheckFailed();
    }

    return result;
}
